<template>
  <layout-default-filters @open="$_OnOpen" @apply="$_applyQueryString"
  :hideButton="filtroInicial">
    <template #superior>
    <div class='div-geral'>
      <div class='primeiro-filtro'>
        <v-form ref="form">
          <core-date-picker-field clearable
            v-model="filters.createdFrom"
            label="De"
          />

          <core-date-picker-field clearable
            v-model="filters.createdBefore"
            label="Até"
            :rules="createdBeforeRules"
          />
        </v-form>
      </div>
      <div class='segundo-filtro'>
        <div class='radios opacity-switch'>
          <v-radio-group v-model="radioGroup" row>
            <v-radio
              v-for="n in 2"
              :key="n"
              :label="radioLabel[n - 1]"
              :value="n"
            ></v-radio>
          </v-radio-group>
        </div>
        <core-text-field clearable class='txt-filter' @focus='subirForm(1)'
          v-model="nomecliente"
          label='Pessoa'
          :type='inputType'
        />
        <div class='btns-wrap'>
          <v-btn rounded color='primary' class='btns opacity-switch' @click='$_load(0)'>
            <v-icon>mdi-arrow-left-thick</v-icon>
          </v-btn>
          <v-btn rounded color='primary' class='btns opacity-switch reducesize' @click='$_load(1)'>
            <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
          </v-btn>
          <v-btn rounded color='primary' class='btns-mini opacity-switch' @click='$_load(2)'>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <template>
          <div
            class="mx-auto cardlist"
            max-width="500"
            v-if='filtroInicial'
          >
            <v-list two-line class='scroll'>
              <v-list-item-group
                active-class="green--text"
                multiple
              >
                <template v-for="(items, index) in items">
                  <v-list-item :key="items.id">
                    <v-card class='cardpessoa' @click="$_onClickCard(items.clinome,
                    items.cliidcliente)">
                      <b>{{items.cliidcliente}} - {{items.clinome}} </b><br/>
                      <div v-if="items.clinomefantasia">
                        {{items.clinomefantasia}}
                      </div>
                      <div v-if="items.clicpf">
                        {{items.clicpf}}
                      </div>
                    </v-card>
                  </v-list-item>

                  <v-divider
                    v-if="index < items.length - 1"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </div>
        </template>

        <div class='terceiro-filtro'>
           <div class="filtro-status">
            <v-radio-group v-model="$$_filtroStatus" column>
              <v-radio class="radios-status"
                v-for="(label, idx) in statusOptions"
                :key="idx"
                :label="label"
                :value="label"
              ></v-radio>
            </v-radio-group>
           </div>
        </div>
      </div>
    </div>        
  </template>
  </layout-default-filters>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import { COLETA_QUERIES, GENERIC_QUERIES  } from '@/constants/QUERY_FILTERS';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import { COLETA_STORAGE  } from '@/constants/STORAGE';

import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';

import CoreDatePickerField from '@/components/core/date-picker-field/Index.vue';

import CoreTextField from '@/components/core/text-field/Index.vue';

import errorHandler from '@/utils/error-handler';

import storage from '@/services/storage';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default {
  name: 'ViewsHomeFilters',

  components: {
    LayoutDefaultFilters,
    CoreDatePickerField,
    CoreTextField,
  },

  data() {
    return {
      items: [],
      isValid: false,
      radioGroup: 2,
      radioLabel: ['Código', 'Nome'],
      nomecliente: null,
      filtroInicial: true,
      inputType: 'text',
      anterior: {
        parametroAnterior: null,
        nomeAnterior: null,
      },

      loading: false,

      filters: {
        createdFrom: null,
        createdBefore: null,
        codigocliente: null,
      },

      options: {
        page: getSessionStorage(COLETA_STORAGE.page, 1),
        itemsPerPage: 999,
        sortBy: ['cliidcliente'],
        sortDesc: [true],
      },

      createdBeforeRules: [
        () => {
          const from = new Date(this.filters.createdFrom);
          const to = new Date(this.filters.createdBefore);

          return to >= from || 'Data Final deve ser superior a Data Inicial';
        },
      ],
      statusOptions: ['Abertas', 'Encerradas', 'Todas'],
    };
  },

  computed: {
    ...mapState({
      $_cacheCliente: (state) => state.cache.cache_cliente,
      $$_filtroStatusAntigo: (state) => state.coleta.filtroStatusAntigo,
    }),

    $$_filtroStatus: {
    get() {
      return this.$store.state.coleta.filtroStatus
    },
    set(value) {
      this.$store.commit('coleta/SET_FILTRO_STATUS', value)
    }
  }
  },

  methods: {
    ...mapActions({
      $_comparaFiltro: 'filter/equals',
    }),
    ...mapMutations({
      $_setRefresh: 'filter/refresh',
    }),

    async $_load(parametroLoad) {
      this.loading = true;
      const ant = this.anterior;
      try {
        const LIMITE = 500;

        if ((typeof this.nomecliente) === 'string') {
          this.filters.codigocliente = this.nomecliente.toUpperCase();
        } else {
          this.filters.codigocliente = this.nomecliente;
        }

        // Evitar requests repetidos.
        if (parametroLoad === ant.parametroAnterior && this.nomecliente === ant.nomeAnterior) {
          return;
        }
        this.anterior.parametroAnterior = parametroLoad;
        this.anterior.nomeAnterior = this.nomecliente;

        if (parametroLoad === 2) {
          this.nomecliente = '';
          storage.setItem(COLETA_STORAGE.textofiltro, '');
          this.filters.codigocliente = 'null';
          this.subirForm(0);
          return;
        }

        if (this.nomecliente) {
          if (this.radioGroup === 2) {
            const termo = this.filters.codigocliente.toLowerCase();

            let filtrados = [];

            if (parametroLoad === 0) {
              filtrados = this.$_cacheCliente.filter((c) =>
                c.clinome?.toLowerCase().startsWith(termo)
              );
            } else {
              filtrados = this.$_cacheCliente.filter((c) =>
                c.clinome?.toLowerCase().includes(termo)
              );
            }

            this.items = filtrados.slice(0, LIMITE);
          } else {
            const filtrados = this.$_cacheCliente.filter(
              (c) => c.cliidcliente == this.nomecliente
            );
            this.items = filtrados.slice(0, LIMITE);
          }
        } else {
          this.items = this.$_cacheCliente.slice(0, LIMITE);
        }

        return;
      } catch (err) {
        errorHandler.call(this, err);
      } finally {
        this.loading = false;
      }
    },

    $_applyQueryString() {
      const queryAntiga = {
        createdFrom: getQueryValue(COLETA_QUERIES.createdFrom),
        createdBefore: getQueryValue(COLETA_QUERIES.createdBefore),
        codigocliente: getQueryValue(COLETA_QUERIES.codigocliente),
        status: this.$$_filtroStatusAntigo,
      };

      this.$_comparaFiltro({ queryAntiga, query: { 
        ...this.filters,
          status: this.$$_filtroStatus,
        } })
        .then((res) => {
          if (res) this.$_setRefresh('S');
        })
        .catch(() => {});
      
      setQueryValue(GENERIC_QUERIES.page, 1);
      setQueryValue(COLETA_QUERIES.createdFrom, this.filters.createdFrom);
      setQueryValue(COLETA_QUERIES.createdBefore, this.filters.createdBefore);
      setQueryValue(COLETA_QUERIES.codigocliente, this.filters.codigocliente);
      setQueryValue('status', this.$$_filtroStatus);
      this.$store.commit('coleta/SET_FILTRO_STATUS_ANTIGO', this.$$_filtroStatus)
    },

    $_OnOpen() {
      this.subirForm(false);
    },

    subirForm(bool) {
      const opacity = document.querySelectorAll('.opacity-switch');
      if (bool) {
        if (this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '0';
        document.querySelector('.primeiro-filtro').style.zIndex = '-1';
        document.querySelector('.segundo-filtro').style.top = '-210px';
        document.querySelector('.terceiro-filtro').style.display = 'none';
        for (let i = 0; i < opacity.length; i += 1) {
          opacity[i].style.opacity = '1';
        }

        this.filtroInicial = true;
      } else {
        if (!this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '1';
        document.querySelector('.primeiro-filtro').style.zIndex = '2';
        document.querySelector('.segundo-filtro').style.top = '-49px';
        document.querySelector('.terceiro-filtro').style.display = '';
        for (let i = 0; i < opacity.length; i += 1) {
          opacity[i].style.opacity = '0';
        }
        this.filtroInicial = false;
      }
    },

    $_FilterReset() {
      this.filters.createdFrom = getQueryValue(COLETA_QUERIES.createdFrom, this.filters.createdFrom);
      this.filters.createdBefore = getQueryValue(
        COLETA_QUERIES.createdBefore,
        this.filters.createdBefore,
      );
    },

    $_onClickCard(nome, codigo) {
      if (this.filtroInicial) {
        this.nomecliente = `${codigo} - ${nome}`;

        storage.setItem(COLETA_STORAGE.textofiltro, this.nomecliente);

        this.filters.codigocliente = codigo;
        this.subirForm(0);
      }
    },
  },

  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.$refs.form.validate();
        });
      },
    },
    radioGroup: {
      handler() {
        this.nomecliente = '';
        if (this.radioGroup === 1) {
          this.inputType = 'tel';
          document.querySelector('.reducesize').style.opacity = '0.5';
        } else {
          this.inputType = 'text';
          document.querySelector('.reducesize').style.opacity = '1';
        }
        this.$_load();
      },
    },

    $route: {
      deep: true,
      immediate: true,
      handler() {
        console.log('route no filtro');
        this.filters.createdFrom = getQueryValue(
          COLETA_QUERIES.createdFrom,
          this.filters.createdFrom,
        );

        this.filters.createdBefore = getQueryValue(
          COLETA_QUERIES.createdBefore,
          this.filters.createdBefore,
        );

        this.filters.codigocliente = getQueryValue(
          COLETA_QUERIES.codigocliente,
          this.filters.codigocliente,
        );

        const textofiltro = storage.getItem(COLETA_STORAGE.textofiltro);
        textofiltro.then((result) => { this.nomecliente = result; });
      },
    },
  },
};
</script>

<style scoped>

  .div-geral {
    height: 0%;
  }

  .btns-wrap {
    display: flex;
    justify-content: space-around;
    height: 50px;
  }

  .opacity-switch {
    transition: opacity 0.3s;
  }

  .btns {
    width: 33%;
    transition: opacity 0.3s;
    opacity: 0;
  }

  .btns-mini {
    width: 10%;
    transition: opacity 0.3s;
    opacity: 0;
  }

  .primeiro-filtro {
    transition: opacity 0.3s;
    position: relative;
    opacity: 1;
    z-index: 1;
  }

  .segundo-filtro {
    transition: top 0.4s;
    position: relative;
    z-index: 1;
    height: 0px;
  }

  .radios {
    transition: opacity 0.3s;
    opacity: 0;
  }

  .mx-auto.cardlist {
    transition: opacity 0.3s;
    transition: top 0.4s;
    height: 50vh;
    overflow-y: scroll;
    background-color: rgb(245, 245, 245);
  }

  .cardpessoa {
    min-height: 80px;
    max-height: relative;
    width: 100%;
    margin-top: 5px;
    padding: 1px 0px 0px 3px;
  }

  /deep/ .txt-filter {
   height: 50px;
  }

.terceiro-filtro {
  transition: opacity 0.3s;
  position: relative;
  opacity: 1;
  z-index: 1;
  top: -30px;
  
}

.filtro-status {
  display: flex;
  justify-content: left;
}
.radios-status {
  flex-direction: row ;
  flex-wrap: nowrap ;
}
</style>
